import React from 'react';
import { t } from 'i18next';
import './EmailTemplate.css';
import AppButton from '../../../components/AppButton/AppButton';

const EmailTemplate = () => {
  return (
    <div>
      <div className="template-main min-h-screen px-8 pb-4 pt-6">
        <div className="template-main-content px-10 py-6">
          <div className="flex gap-2">
            <div className="flex pb-1">
              <img
                className="w-12 lg:w-16"
                src={`https://esscanpstorage.blob.core.windows.net/esscimages/AnpLogo.png`}
                alt={t('anpLogo', 'ANP Logo')}
              />
              <h6 className="logo-text ml-2 mt-2 text-[10px] font-light sm:text-[10px] sm:font-light md:text-[10px] md:font-semibold lg:text-[14px] lg:font-bold">
                {t('enterpriseSupportServiceCenter', 'Enterprise Support Service Center')}
              </h6>
              {/* <div className="ml-1 border-r-4 border-yellow-300"></div> */}
            </div>
            {/* <div className="flex pb-1">
              <img
                className="w-12 sm:w-12 md:w-12 lg:w-16"
                src={`https://esscanpstorage.blob.core.windows.net/esscimages/AnpLogo2.png`}
                alt={t('anpLogo2', 'ANP Logo')}
              />
              <h6 className="logo-text2 ml-2 mt-2 text-[10px] font-light sm:text-[10px] sm:font-light md:text-[10px] md:font-semibold lg:text-[14px] lg:font-bold">
                {t('autoridadeNacional', 'Autoridade Nacional')}
                <br />
                {t('DoPetroleo', 'Do Petroleo')}
                <br />
                {t('timorLeste', 'Timor - Leste')}
              </h6>
            </div> */}
          </div>
          <p className="font-bold">Autoridade Nacional Do Petroleo Timor - Leste</p>
          <h1 className="mb-8 mt-8 text-4xl font-bold">Successful Registration</h1>
          <p className="text-xl">Hi [Supplier]</p>
          <p className="mb-6 mt-4 text-xl">
            Congratulations! Your registration on the ESSC Portal has been successfully completed.
            We’re excited to have you on board and look forward to providing you with a seamless
            experience.
          </p>
          <div className="mb-5 w-[200px] cursor-pointer bg-green-700 py-3 text-center font-bold text-white">
            <AppButton
              title={'Click to Proceed'}
              onClick={function (): void {
                alert('success');
              }}
            />
          </div>
        </div>
        <div className="px-10">
          <p className="mt-3">ESSC Portal at the touch of a button! Download our app for:</p>
          <div className="mt-3 flex gap-2">
            <div>
              <img
                className=""
                src={`https://esscanpstorage.blob.core.windows.net/esscimages/app-store.svg`}
                alt={'app store'}
              />
            </div>
            <div>
              <img
                className=""
                src={`https://esscanpstorage.blob.core.windows.net/esscimages/google-play-badge.png`}
                alt={'google play'}
              />
            </div>
          </div>
          <p className="mt-6">
            Questions or concerns? Get in touch with us at{' '}
            <span className="text-green-700">xxx@email.com</span> or{' '}
            <span className="text-green-700">555-555-555</span>.
          </p>
          <p className="mb-6">
            Never miss a beat! Follow us on <span className="text-green-700">Twitter</span>,{' '}
            <span className="text-green-700">Facebook</span> and{' '}
            <span className="text-green-700">Instagram</span>.
          </p>
          <p>Don’t want any more emails from ANP-ESSC ? Unsubscribe. </p>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplate;
